/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

import * as overrides from '../../operation-overrides/internalGetAutomatedReleaseLegacyOverrides';

export type InternalGetAutomatedReleaseLegacyPathParams = NonNullable<
  operations['internalGetAutomatedReleaseLegacy']['parameters']['path']
>;

export interface Input extends InternalGetAutomatedReleaseLegacyPathParams {
  apiVersion?: string;
}

export async function internalGetAutomatedReleaseLegacy(
  { apiVersion, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET(
    '/internal/projects/{projectKey}/environments/{environmentKey}/automated-releases/{automatedReleaseId}',
    {
      params: { path },
      headers: mergeHeaders(headers, { 'LD-API-Version': apiVersion ?? overrides.apiVersion }),
      signal,
    },
  );
}
